import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    keywords,
    image = '/generic-company-logo.png',
    url,
    type = 'website',
    schema
}) => {
    const siteUrl = 'https://www.rainbowcraft.ae';
    const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
    const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

    const defaultTitle = 'Rainbow Craft - Best Signage & Branding Company in Abu Dhabi, UAE';
    const defaultDescription = 'Rainbow Craft Signs & Graphics LLC - Based in Abu Dhabi Musaffah, serving all UAE. Expert LED signage, neon signs, 3D lettering, vehicle wrapping, and corporate branding.';
    const defaultKeywords = 'rainbow craft, rainbowcraft, rainbow craft abu dhabi, rainbow craft musaffah, rainbow craft uae, best signage company abu dhabi, best signage company uae, top signage company, leading signage company, rainbow craft signs, rainbow craft signs & graphics, professional signage services uae, custom signage solutions';

    const seoTitle = title ? `${title} | Rainbow Craft Signs & Graphics LLC` : defaultTitle;
    const seoDescription = description || defaultDescription;
    const seoKeywords = keywords || defaultKeywords;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{seoTitle}</title>
            <meta name="title" content={seoTitle} />
            <meta name="description" content={seoDescription} />
            <meta name="keywords" content={seoKeywords} />
            <link rel="canonical" href={fullUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={seoTitle} />
            <meta property="og:description" content={seoDescription} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:locale" content="en_AE" />
            <meta property="og:site_name" content="Rainbow Craft Signs & Graphics LLC" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={seoTitle} />
            <meta property="twitter:description" content={seoDescription} />
            <meta property="twitter:image" content={imageUrl} />

            {/* Geographic Meta Tags */}
            <meta name="geo.region" content="AE-DU" />
            <meta name="geo.placename" content="Dubai, UAE" />

            {/* Schema.org Structured Data */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
